import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=f657ff22&"
import script from "./Workflow.vue?vue&type=script&lang=js&"
export * from "./Workflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f657ff22')) {
      api.createRecord('f657ff22', component.options)
    } else {
      api.reload('f657ff22', component.options)
    }
    module.hot.accept("./Workflow.vue?vue&type=template&id=f657ff22&", function () {
      api.rerender('f657ff22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Workflow.vue"
export default component.exports